"use strict";

var _interopRequireDefault = require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRouters = void 0;
var _request = _interopRequireDefault(require("@/utils/request"));
var _cloud = require("@/utils/cloud");
// 获取路由
var getRouters = exports.getRouters = function getRouters() {
  return (0, _request.default)({
    url: _cloud.urls.user + '/getRouters',
    method: 'get'
  });
};